import React, { useState, useEffect } from "react";
import Navbar from "../Components/Navbar";
import { useNavigate, useLocation } from "react-router-dom";
import HelpMessage from "../Components/HelpMessage";
import axios from "axios";
import SearchBar from "../Components/SearchBar";
import { fetchSupplierDataForHome } from "../Components/Search";

const Home = () => {
  const [userData, setUserData] = useState(null);
  const [volumeData, setVolumeData] = useState([]);
  const [proceduresData, setProceduresData] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const userRole = localStorage.getItem("role");
        const isAdmin = userRole && userRole.includes("admin");
        let supplierData = localStorage.getItem("currentUser");
        if (!supplierData) {
          try {
            const response = await axios.get(
              process.env.REACT_APP_API_BASEURL + "/supplierNames"
            );
            supplierData = response.data[0].supplier;
          } catch (error) {
            console.error("Error fetching supplier data:", error);
          }
        }
        let fetchedData;
        if (isAdmin) {
          // Pass supplierData.id instead of supplierData
          const response  = await fetchSupplierDataForHome(supplierData);
          // setUserData(fetchedData);
          // setVolumeData(volumeData);

          setUserData(response.userData);
          setVolumeData(response.volumeData);
          setProceduresData(response.resultProcedure);
        } else {
          const response = await fetchAllData();
          setUserData(response.userData);
          setVolumeData(response.volumeData);
          setProceduresData(response.resultProcedure);
        }
      } catch (error) {
        console.error("Error fetching data for Home:", error);
      }
    };

    fetchData();
  }, []);
  const handleCardClick = (monthData) => {
    const userRole = localStorage.getItem("role");
    const isAdmin = userRole && userRole.includes("admin");

    if ( isAdmin ) {
      monthData.supplier = localStorage.getItem("currentUser").trim();
    }

    localStorage.setItem("currentCard", JSON.stringify(monthData));
    const volumeValue = volumeByMonthYear[`${getMonthName(monthData.month)} ${
      monthData.year
    }`] || 0;
    // Save the volume value in local storage
    localStorage.setItem("volumeValue", volumeValue);
    navigate(`/Results`);
  };
  const fetchAllData = async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(process.env.REACT_APP_API_BASEURL + "/api/Home/data", {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      return response.data; // Return the entire response, including both userData and volumeData
    } catch (error) {
      console.error("Error fetching data:", error);
      throw error;
    }
  };
  const getMonthName = (monthNumber) => {
    const months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    return months[monthNumber - 1];
  };
  
   
    const volumeByMonthYear = {};
  // Calculate total volume for each month
  volumeData.forEach((entry) => {
    const monthName = getMonthName(entry.month);
    const year = entry.year;
    const key = `${monthName} ${year}`;

    if (!volumeByMonthYear[key]) {
      volumeByMonthYear[key] = 0;
    }

    volumeByMonthYear[key] += entry.vol;
  });
  
  
  const renderDataByMonths = () => {
    const dataByMonths = {};

    // Group data by months
    userData.forEach((entry) => {
      const monthName = getMonthName(entry.month);
      const year = entry.year;
      const key = `${monthName} ${year}`;

      if (!dataByMonths[key] || entry.day > dataByMonths[key].day) {
        dataByMonths[key] = entry;
      }
    });
    // Sort months in descending order
    const sortedMonths = Object.values(dataByMonths).sort(
      (a, b) =>
        new Date(b.year, b.month - 1, b.day) -
        new Date(a.year, a.month - 1, a.day)
    );

    return (
      <>
        {proceduresData.recordsets[1].map((monthData, index) => {
          const monthYearKey = `${getMonthName(monthData.month)} ${
            monthData.year
          }`;
          return (
            <div key={index}>
              <div
                className="home_page_single"
                id="result"
                onClick={() => handleCardClick(monthData)}
              >
                <div className="tr date">
                  <div className="td" colSpan="4">
                    {getMonthName(monthData.month)} {monthData.year}
                  </div>
                </div>

                <div className="green custom_design tr">
                  <div className="custom-half">
                    <div className="display-option-wrap">
                      <div className="td odd heading text-right">
                        VOLUME: {monthData.CollectedVol || 0}
                      </div>
                    </div>
                  </div>

                  <div className="custom-half pl-50">
                    <div className="td odd heading text-right">BF:</div>
                    <div className="td odd text-left">{monthData.BF}</div>
                  </div>
                </div>

                <div className="tr white custom_design">
                  <div className="custom-half">
                    <div className="display-option-wrap">
                      <div className="td heading text-right">
                        PRT : {monthData.PRT}
                      </div>
                    </div>
                  </div>

                  <div className="custom-half pl-50">
                    <div className="td odd heading text-right">SCC :</div>

                    <div className="td odd text-left">{monthData.SCC}</div>
                  </div>
                </div>

                <div className="green custom_design tr">
                  <div className="custom-half">
                    <div className="display-option-wrap">
                      <div className="td heading text-right">BAC : {monthData.BAC}</div>
                    </div>
                  </div>

                  <div className="custom-half pl-50">
                    <div className="td heading text-right">BSE : {monthData.BSE}</div>

                    <div className="td text-left"></div>
                  </div>
                </div>

                <div className="tr white custom_design">
                  <div className="custom-half">
                    <div className="display-option-wrap">
                      <div className="td heading text-right">
                        FPD : {monthData.FPD}
                      </div>
                    </div>
                  </div>

                  <div className="custom-half pl-50">
                    <div className="td heading text-right">ANT : </div>

                    <div className="td text-left">{monthData.ANT}</div>
                  </div>
                </div>

                <div className="green custom_design tr">
                  <div className="custom-half">
                    <div className="display-option-wrap">
                      <div className="td heading text-right">UREA : {monthData.UREA}</div>
                    </div>
                  </div>

                  <div className="custom-half pl-50">
                    <div className="td heading text-right">SIGHT : 0</div>

                    <div className="td text-left"></div>
                  </div>
                </div>

                <div className="tr white custom_design">
                  <div className="custom-half">
                    <div className="display-option-wrap">
                      <div className="td heading text-right">BCFU : {monthData.BCFU}</div>
                    </div>
                  </div>

                  <div className="custom-half pl-50">
                    <div className="td heading text-right">SBCFU : </div>
                    <div className="td text-left">{monthData.SBCFU}</div>
                  </div>
                </div>
              </div>

              { monthData.Payment && <>
                <div className="month-payment-row">
                  <div className="month-payment-col">
                    <div className="month-payment">Payment</div>
                  </div>
                  <div className="month-payment-col">
                    <div className="month-payment">{monthData.Payment}</div>
                  </div>
                </div>
              </> }

            </div>
          );
        })}
      </>
    );
  };


  return (
    <>
      <div className="container-login100">
        <div className="wrap-login100">
          <Navbar />
          <div className="tableft">
            <a>Home</a>
          </div>
          <div id="result-wrapper">
            <SearchBar />
            {proceduresData && proceduresData.recordsets && proceduresData.recordsets[1] ? (
              <>{renderDataByMonths(userData, volumeData, volumeByMonthYear)}</>
            ) : (
              <p>Loading user data...</p>
            )}
          </div>
          <HelpMessage />
        </div>
      </div>
    </>
  );
};

export default Home;
